import { get, flow } from 'lodash/fp';

export const getEditManyUsersState = get('editManyUsers');
export const previewTable = flow(getEditManyUsersState, get('previewTable'));
